module.exports = __webpack_public_path__ + "static/media/shichangbuzuoyeliucheng.566691a2.png";